// extracted by mini-css-extract-plugin
export default {"root":"Badge_root-Sdg","success":"Badge_success-_4x","error":"Badge_error-yGG","neutral":"Badge_neutral-zpo","onTint":"Badge_onTint-QZG"};